import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Strings from "../utils/stringUtil";
import styles from "../assets/styles/main.module.css";
import { isMobile } from "../utils/responsiveUtil";
import TextSize from "../utils/textSizeUtil";
import theme from "../utils/themeUtil";
import { accordionsQA } from "../components/faqAccordions/accordionQA";
import Seo from "../components/seo";
import withLoader from "../components/ui/withLoader";

function Faq() {
  const [expandedMainAccordion, setExpandedMainAccordion] = useState("");
  const [expandedNestedAccordion, setExpandedNestedAccordion] = useState("");

  const [expandedNestedAccordionKey, setExpandedNestedAccordionKey] =
    useState("");

  const handleChange = (panel) => (event, newExpanded) => {
    if (newExpanded) {
      setExpandedMainAccordion(panel);
      // Reset the nested accordion state when a new main accordion is expanded
      setExpandedNestedAccordion("");
    } else {
      setExpandedMainAccordion("");
    }
  };

  const handleNestedChange = (panel) => (event, newExpanded) => {
    setExpandedNestedAccordion(newExpanded ? panel : "");
    setExpandedNestedAccordionKey(newExpanded ? panel : "");
  };

  return (
    <React.Fragment>
      <Seo
        title={Strings.faqsMetaTitle}
        description={Strings.faqsMetaDescription}
        keywords={Strings.faqsMetaKeyword}
      />
      <Box mt={5} textAlign="left">
        <Box className={styles.container}>
          <Box mb={isMobile ? 2 : 4}>
            <Typography
              style={{
                fontSize: isMobile ? TextSize.size20 : TextSize.size24,
                fontWeight: "bold",
                color: theme.palette.black.main,
              }}
            >
              {Strings.faqTitle}
            </Typography>
          </Box>

          <Box className={styles.faqAccordion}>
            {accordionsQA.map((mainAccordion) => (
              <Accordion
                key={mainAccordion.key}
                expanded={expandedMainAccordion === mainAccordion.key}
                onChange={handleChange(mainAccordion.key)}
                style={{ marginBottom: "16px", boxShadow: "none" }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  style={{
                    background: "#CBE3FB",
                    borderTopLeftRadius: "8px",
                    height: "50px",
                    borderTopRightRadius: "8px",
                  }}
                >
                  <Typography variant="subtitle1" fontWeight="bold">
                    {mainAccordion.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails style={{ padding: "0px" }}>
                  {mainAccordion.nested &&
                    mainAccordion.nested.map((nestedAccordion) => (
                      <Accordion
                        key={nestedAccordion.key}
                        expanded={
                          expandedNestedAccordion === nestedAccordion.key
                        }
                        onChange={handleNestedChange(nestedAccordion.key)}
                        className={styles.nestedAccordionStyle}
                        style={{
                          paddingTop: "8px",
                          paddingBottom: "8px",
                          backgroundColor:
                            expandedNestedAccordionKey === nestedAccordion.key
                              ? "#CBE3FB"
                              : "inherit",
                          boxShadow: "inherit",
                          borderRadius: "8px",
                        }}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography
                            variant={
                              expandedNestedAccordionKey === nestedAccordion.key
                                ? "subtitle2"
                                : "subtitle1"
                            }
                            color={
                              expandedNestedAccordionKey === nestedAccordion.key
                                ? theme.palette.blue.main
                                : "inherit"
                            }
                          >
                            {nestedAccordion.question}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{ paddingTop: "0px", paddingBottom: "16px" }}
                        >
                          <Box
                            sx={{
                              "& ul": {
                                listStyleType: "disc",
                                paddingLeft: "20px",
                                fontSize: "16px",
                              },
                              "& li": {
                                marginBottom: "8px",
                                listStyleType: "disc",
                              },
                            }}
                            style={{ fontSize: "16px" }}
                            dangerouslySetInnerHTML={{
                              __html: nestedAccordion.answer,
                            }}
                          ></Box>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}

export default withLoader(Faq);
